import { Loading } from "element-ui";

var loading = null;
var loading_options = {
  fullscreen: false,
  target: document.querySelector("body"),
  lock: true,
  text: "请稍候...",
  spinner: "el-icon-loading",
  background: "rgba(0, 0, 0, 0.9)"
};
const showLoading = params => {
  // Loading.service(loading_options);
  try {
    console.log("ssss", loading);
    if (loading) {
      setTimeout(() => {
        if (loading.hasOwnProperty("close")) {
          loading.close();
        }
      }, 250);
    }
    Object.assign(loading_options, params);
    loading = Loading.service(loading_options);
  } catch (e) {
    console.log(e);
  }
};

const hideLoading = () => {
  // let loadingInstance = Loading.service(options);
  // this.$nextTick(() => {
  //   // 以服务的方式调用的 Loading 需要异步关闭
  //   loadingInstance.close();
  // });
  if (loading) {
    loading.close();
    loading = null;
  }
};

export { showLoading, hideLoading, loading_options };
